import { HTLCPublicClient, } from '@train-protocol/sdk';
import { JsonRpcClient } from '../rpc.js';
import { getUserLockDetails } from './public/getUserLockDetails.js';
import { getSolverLockDetails } from './public/getSolverLockDetails.js';
import { recoverSwap } from './public/recoverSwap.js';
import { getTransaction } from './public/getTransaction.js';
export class EvmHTLCPublicClient extends HTLCPublicClient {
    constructor(config) {
        super();
        this.rpc = new JsonRpcClient(config.rpcUrl);
    }
    async getUserLockDetails(params) {
        return getUserLockDetails(this.rpc, params);
    }
    async getSolverLockDetails(params, nodeUrl) {
        return getSolverLockDetails(params, nodeUrl);
    }
    async recoverSwap(txHash, network) {
        return recoverSwap(this.rpc, txHash, network);
    }
    async getTransaction(txHash) {
        return getTransaction(this.rpc, txHash);
    }
}
